<template>
    <div>
      <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
      <!--列表  show-summary-->
      <el-table size="small" show-summary :summary-method="getSummaries" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" sortable prop="date" label="日期" >
        </el-table-column>
        <el-table-column align="center" prop="userCount" label="注册人数" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="usdt_In" label="转入的USDT" >
        </el-table-column> -->
        <el-table-column align="center" prop="usdt_Out" label="转出的USDT" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="eth_In" label="转入的ETH" >
        </el-table-column> -->
        <el-table-column align="center" prop="winRate" label="游戏拨出比例" min-width="100">
          <template slot-scope="scope">
            {{ (scope.row.winRate * 100).toFixed(2) + '%' }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="eth_Out" label="转出的ETH" >
        </el-table-column> -->
        <el-table-column align="center" prop="minerTotal" label="购买矿机总额U" >
        </el-table-column>
        <el-table-column align="center" prop="totalDet" label="游戏投注G" >
        </el-table-column>
        <el-table-column align="center" prop="totalBack" label="游戏返还G" >
        </el-table-column>
        <el-table-column align="center" prop="totalWin" label="游戏盈利M" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="totalWin2" label="游戏盈利H" >
        </el-table-column> -->
        <el-table-column align="center" prop="totalRelease" label="挖矿数G" >
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { historyList } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        formInline: {
          from: 1,
          limit: 10,
          startTime: "",
          endTime: ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        timeVal:""
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        historyList(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.from
              // this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      getSummaries(param) {
        const { columns, data } = param;
        // console.log(columns, data)
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          // console.log(values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // sums[index] += ' 元';
          } else {
            sums[index] = 'N/A';
          }
        });

        if(sums[6] == 0 || (sums[7]+sums[8]+sums[9]) == 0){
          sums[4] = 0
        }else{
          sums[4] = ((sums[7]+sums[8]+sums[9])/(sums[6])*100).toFixed(2) + '%'
        }
        // 
        // console.log()
        return sums;
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.pageSize = parm.pageSize
        this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.pageparm.currentPage = 1
        this.formInline.from = 1
        console.log(this.timeVal)
        if(this.timeVal instanceof Array){
          this.formInline.startTime = this.timeVal[0]+' 00:00:00'
          this.formInline.endTime = this.timeVal[1]+' 23:59:59'
        }else{
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
        this.getdata(this.formInline)
      }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/data/History.vue